import React, { type ReactElement } from 'react';

import { cssMap } from '@atlaskit/css';
import { CloseButton } from '@atlaskit/modal-dialog';
import { Box } from '@atlaskit/primitives/compiled';
import { token } from '@atlaskit/tokens';

const styles = cssMap({
	rightSide: {
		position: 'relative',
		display: 'inlineBlock',
		overflow: 'hidden',
	},
	button: {
		position: 'absolute',
		top: token('space.250'),
		right: token('space.250'),
	},
});

export const SideContentWithModalCloseButton = (
	component: ReactElement,
	onClickHandler: () => void,
) => {
	return (
		<Box xcss={styles.rightSide}>
			{component}
			<Box xcss={styles.button}>
				<CloseButton testId="upft-experiment-modal" onClick={onClickHandler} />
			</Box>
		</Box>
	);
};
